/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { MyRequestService } from '@src/app/modules/crm/my-request.service';
import { PersonalRequestPageNavRoute } from '@src/app/routes/app-router';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';

@Component({
    selector: 'app-my-requests-widget',
    imports: [RouterLink, MatButtonModule],
    templateUrl: './my-requests-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class MyRequestsWidgetComponent  implements IWidget, OnInit {
  title = $localize `Reports Issue / Your Requests`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  @Input() chosenWidget: ChosenWidget;

  reqSvc = inject(MyRequestService)
  routerLink = PersonalRequestPageNavRoute.getListRouterLink();

  openRequests: ServiceRequest[] = []; 
  resolvedRequests: ServiceRequest[] = [];
  acceptedRequests: ServiceRequest[] = [];

  ngOnInit(): void {
    const parms = new HttpParams().set('srStatus', '!=accepted').set('_sortDesc', 'updatedAt');
    this.reqSvc.get<ServiceRequest>(false, parms).subscribe( data => {
      this.openRequests = data.filter(sr => sr.srStatus === ServiceRequest.srOpen.id);
      this.resolvedRequests = data.filter(sr => sr.srStatus === ServiceRequest.srResolved.id);
      this.resolvedRequests = data.filter(sr => sr.srStatus === ServiceRequest.srAccepted.id);
    })
  }

  getNavRoute(sr: ServiceRequest) {
    return [PersonalRequestPageNavRoute.getIdUrl(sr.id, sr.teamId)];
  }
}
